import { path } from 'd3-path'
import Symbol2d from '../2d.js'

function yIntersection (dimensions) {
  const line = [[0, dimensions.height / 3], [dimensions.width / 2, 0]]

  // Calculate slope (m) of the line
  const m = (line[1][1] - line[0][1]) / (line[1][0] - line[0][0])

  // Calculate y-intercept (b) of the line
  const b = line[0][1] - m * line[0][0]

  // Find y coordinate of the intersection
  return m * (dimensions.width * 0.2) + b
}

export default class Pentagon extends Symbol2d {

  path (dimensions, handles) {
    const _path = path()
    _path.moveTo(dimensions.width / 2, 0) // Top center
    _path.lineTo(dimensions.width, dimensions.height / 3) // Right top
    _path.lineTo(dimensions.width * 0.8, dimensions.height) // Right bottom
    _path.lineTo(dimensions.width * 0.2, dimensions.height) // Left bottom
    _path.lineTo(0, dimensions.height / 3) // Left top
    _path.closePath()
    return _path.toString()
  }

  textContainer (dimensions) {
    const width = dimensions.width * .6
    // Find y intersection of the two lines
    const y = yIntersection(dimensions)
    const height = dimensions.height - y

    const centerY = y + height / 2

    return {
      center: [dimensions.center[0], centerY],
      width,
      height
    }
  }

}
